import { render } from "./RechargeKkiaPayPage.vue?vue&type=template&id=d0d255ea&ts=true"
import script from "./RechargeKkiaPayPage.vue?vue&type=script&lang=ts"
export * from "./RechargeKkiaPayPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__